module.exports = __webpack_public_path__ + "hu.svg?7550d6705c9f14a2d798b4193e037ffb";